<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
			<div class="row" style="position: relative;">
				<img src="../../assets/img/lxwmBanner.png" style="width: 100%;" />
				
			</div>

			<div class="prduct-box">		
				<div class="xwzx-box">
					<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;margin-top: 45px;">
						免费体验 预约演示
					</div>
					<div class="row ju-c al-c" style="margin-top: 20px;">
						<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
					</div>
					<div style="width: 1200px;margin: 0 auto;margin-top: 80px;">
						<div class="row">
							<div class="item" style="flex: 1;margin-right: 10px;">
								<input v-model="params.name" class="ipt-cl" placeholder="姓名"/>
							</div>
							<div class="item" style="flex: 2;margin-right: 10px;">
								<input  v-model="params.company" class="ipt-cl" placeholder="公司名称"/>
							</div>
							<div class="item" style="flex: 1;">
								<input v-model="params.phone" class="ipt-cl" placeholder="手机"/>
							</div>
						</div>
						
						<div class="row" style="margin-top: 40px;">
							<textarea v-model="params.issue" class="tt-cla" placeholder="您的服务需求"></textarea>
						</div>
						
						<div class="row al-c" style="margin-top: 40px;">
							<div class="item-no btn ju-c" @click="toCommit">
								点击提交
							</div>
							<div class="item-no" style="font-size: 16px;color: #999;margin-left: 25px;">
								您填写的资料会被严格保密，我们会有专人与您联系!
							</div>
						</div>
					</div>
				</div>
				<!-- <baidu-map id='container' class="bmView" ></baidu-map> -->

				
			</div>
			<Foot />
		</div>
	</div>
</template>

<script>
	import {commit} from '@/api/api.js'
	import Nav from "./nav.vue";
	import Foot from "./foot.vue";
	export default {
		name: "App",
		components: {
			Nav,
			Foot
		},
		data() {
			return {
				curHeight: 0,
				location: {
					lng:113.53077, 
					lat: 33.57160
				},
				zoom: 6,
				addressKeyword: "",
				params:{},
				
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			 baiduMap () {
				 var map = new BMap.Map('container')
				 map.enableScrollWheelZoom(true);
				 var center = new BMap.Point(113.53077, 33.57160)
				 var point = new BMap.Point(121.183205,31.169685)
				 map.centerAndZoom(center, 6)
				 var marker = new BMap.Marker(point) // 创建标注
				 map.addOverlay(marker)    // 将标注添加到地图中
			 },
			 toCommit(){
				 this.$api.api.commit(this.params).then((res) => {
				   if (res.data.success) {
						this.$Message.success('提交成功');
						this.params={}
				   } else {
						this.$Message.warning('提交失败');
				   }
				 })
			 }
			 
		},
		mounted() {
			var that = this;
			// this.baiduMap()
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>
	.main-content {
		min-height: 100%;
		min-width: 1400px;
		width: 100%;
		margin: 0 auto;
		display: block;
		position: absolute;
		/* background: #f7f7f7; */
	}

	.prduct-box {
		width: 1200px;
		/* padding-top: 60px; */
		padding-bottom: 100px;
		margin: 0 auto;
	}

	.center-body {
		margin: 0 auto;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}
	.bmView{
		height: 600px;
		margin-top: 40px;
		/* position: relative; */
	}
	.ipt-cl{
		border-radius: 25px;
		height: 50px;
		border:1px solid #999;
		width: 100%;
		padding:0 25px;
		font-size: 20px;
		line-height: 50px;
		color: #333;
	}
	.tt-cla{
		border-radius: 25px;
		width: 100%;
		border:1px solid #999;
		resize: none;
		height: 400px;
		padding:15px 25px;
		font-size: 20px;
		color: #333;
		
	}
	.btn{
		background-color: #007dfd;
		width: 150px;
		font-size: 16px;
		line-height: 50px;
		border-radius: 25px;
		height: 50px;
		color: #fff;
		cursor: pointer;
	}
		
</style>
